import type { DeckResult } from "./queries/deckQueries";

export const calculatedDeckSize = (deckSize: DeckResult["deck_size"]) => {
	return {
		main: (deckSize?.mainboard || 0) + (deckSize?.commander || 0),
		side: deckSize?.sideboard || 0,
	};
};
